export const MP_LOGO_URL = "images/Mercado_Pago.svg";

export const PROVEEDOR_PAGO = {
    MERCADO_PAGO: 1,
    EFECTIVO: 2,
    TARJETA: 3,
    CBU: 4,
} as const;

export type ProveedorPagoCode = (typeof PROVEEDOR_PAGO)[keyof typeof PROVEEDOR_PAGO];
